import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Button, Grid, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../constants';
import { CONSTANTS } from '../../../../constants/constants';
import { connect } from 'react-redux';
import API_REST from '../../../../api-rest-uruk';
import API from '../../../../api-graphql';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main
  }
}));

const CardButton = ({ document, handleDeleteFlow, handleCancelFlow, handleUpdateDocument, markAsReadDocument, appConfig, handleCreateFlowAlert, role }) => {
  const { t } = useTranslation();
  const { markAsRead: appMarkAsRead } = appConfig;
  const { status, flowId, fileUrl } = document;

  const history = useHistory();
  const classes = useStyles();

  let currentStep;
  let flow;
  if (document.flow) {
    flow = JSON.parse(document.flow);
    currentStep = flow.steps.find(step => step.status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN);
  }

  const downloadPdfCertificateEvidence = async () => {
    API_REST.getCertificate(flowId)
      .then(response => window.open(response, '_blank'))
      .catch(err => console.error('[ERROR]: ', err));
  };

  const handleCreateFlow = () => {
    API.getDocument(document.id).then(response => {
      if (response.data.getDocument.principal.signaturesPositions) { history.push(`/document/flow/${document.id}`); } else { handleCreateFlowAlert(true); }
    });
  };

  const isSigner = role === CONSTANTS.ROLES.SIGNER;

  const canCreateFlow = !isSigner && status === CONSTANTS.FLOW.STATUS.INIT;
  const canDownloadCertificate = !isSigner && fileUrl && (flow && flow.certifiedEvidence && flow.certifiedEvidence === 'true') &&
  [CONSTANTS.FLOW.STATUS.SIGNED, CONSTANTS.FLOW.STATUS.ERROR, CONSTANTS.FLOW.STATUS.REJECTED, CONSTANTS.FLOW.STATUS.EXPIRED].includes(status);
  const canDelete = !isSigner && (status === CONSTANTS.FLOW.STATUS.REJECTED || status === CONSTANTS.FLOW.STATUS.CANCELLED || status === CONSTANTS.FLOW.STATUS.INIT || status === CONSTANTS.FLOW.STATUS.ERROR);
  const canCancel = !isSigner && status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN && currentStep && !currentStep.automatic;

  return (
    <>
      {canCreateFlow &&
        <Grid item>
          <Button
            component={RouterLink}
            variant='contained'
            color='primary'
            onClick={() => handleCreateFlow()}
          >
            {t('documentMenu:createFlow')}
          </Button>
        </Grid>
      }
      {canDownloadCertificate &&
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          component={RouterLink}
          onClick={() => downloadPdfCertificateEvidence()}
        >
          {t('documentMenu:PDFCertificate')}
        </Button>
      </Grid>
      }
      {fileUrl && status === CONSTANTS.FLOW.STATUS.SIGNED &&
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            component={RouterLink}
            to={`/document/finished/detail/${document.id}`}
          >
            {t('documentMenu:viewDocument')}
          </Button>
        </Grid>
      }
      {fileUrl && status !== CONSTANTS.FLOW.STATUS.SIGNED && <Grid item>
        <Button
          variant='contained'
          color='primary'
          component={RouterLink}
          to={`/document/detail/${document.id}`}
          className='pending-newDocument2'
        >
          {t('documentMenu:viewDocument')}
        </Button>
      </Grid>
      }
      {(status === CONSTANTS.FLOW.STATUS.SEND_TO_SIGN || status === CONSTANTS.FLOW.STATUS.SIGNED) &&
        <Grid item>
          <Button
            component={RouterLink}
            variant='contained'
            color='primary'
            target='_blank'
            to={{ pathname: `${config.FIRMA_FRONT_URL}/validate/${flowId}` }}
          >
            {t('cardButton:viewSignedDocument')}
          </Button>
        </Grid>
      }
      {canDelete &&
        <Grid item>
          <Button
            variant='outlined'
            classes={{ root: classes.root }}
            aria-label='delete' onClick={() => handleDeleteFlow(true)}
          >
            {t('cardButton:delete')}
          </Button>
        </Grid>
      }
      {canCancel &&
        <Grid item>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => handleCancelFlow(true)}
          >
            {t('cardButton:cancel')}
          </Button>
        </Grid>
      }
      {appMarkAsRead && status === CONSTANTS.DOCUMENT.STATUS.SIGNED &&
      <Tooltip title={markAsReadDocument ? t('documentMenu:markAsNotRead') : t('documentMenu:markAsRead')} enterDelay={200} enterTouchDelay={300} placement='bottom'>
        <Grid item>
          <Button
            variant={markAsReadDocument ? 'outlined' : 'contained'}
            color='primary'
            onClick={() => handleUpdateDocument(!markAsReadDocument)}
          >
            {markAsReadDocument && t('documentMenu:notReaded')}
            {!markAsReadDocument && t('documentMenu:readed')}
          </Button>
        </Grid>
      </Tooltip>
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appConfig: state.config,
    role: state.config.role
  };
};

CardButton.propTypes = {
  document: PropTypes.object.isRequired,
  handleDeleteFlow: PropTypes.func.isRequired,
  handleCancelFlow: PropTypes.func.isRequired,
  handleUpdateDocument: PropTypes.func.isRequired,
  appConfig: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(CardButton);
